import React, { useEffect, useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'

import Colors from 'utils/Colors'
import LaunchIcon from '@mui/icons-material/Launch'

import { Modal } from 'components'
import ApplicationLog from 'components/ApplicationLog'
import styles from '../styles'

const ExpandAppButton = ({ application, handleOpenModal }) => {
  const [currentApplication, setCurrentApplication] = useState(null)
  const [logModal, setLogModal] = useState(false)

  useEffect(() => {
    if (currentApplication) setLogModal(true)
  }, [currentApplication])

  const handleCloseLogModal = () => {
    setLogModal(false)
    setCurrentApplication(null)
  }

  const classes = styles()


  return (
    <React.Fragment>
                        <Tooltip
                          arrow
                          placement="top"
                          title={
                            <b className={classes.tooltipText}>
                              Visualizar as informações
                              <br />
                              detalhadas da aplicação
                            </b>
                          }
                        >
                          <IconButton
                            onClick={() => handleOpenModal(application)}
                            size="large"
                          >
                            <LaunchIcon
                              style={{
                                color: Colors.primaryColor,
                                fontSize: 20,
                              }}
                            />
                          </IconButton>
                        </Tooltip>
      <Modal
        open={logModal}
        onClose={() => handleCloseLogModal()}
        title="Registro de atividades da aplicação"
      >
        <ApplicationLog applicationData={currentApplication} />
      </Modal>
    </React.Fragment>
  )
}

export default ExpandAppButton
